import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";
import { USER_TYPE_ICONS } from "../../Utilities/userTypeIcons";

// A user type this component does not know yet (added on the server first) shows a
// question mark and its raw name, rather than a missing icon or a raw translation key
export default function UserTypeIcon({ userType, className = "me-2" }) {
  const intl = useIntl();
  const messageId = `UserType.${userType}`;
  const label = intl.messages[messageId]
    ? intl.formatMessage({ id: messageId })
    : userType;

  return (
    <span className={className} role="img" aria-label={label} title={label}>
      <FontAwesomeIcon
        icon={USER_TYPE_ICONS[userType] ?? "question"}
        fixedWidth
      />
    </span>
  );
}
